import * as analytics from 'analytics/Analytics';
import {AnalyticsEvent} from 'analytics/Analytics';
import {NAV_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {Section} from 'constants/NavConstants';
import {SearchParams} from 'search/SearchConstants';

export enum SortWidget {
  SORT_DROPDOWN = 'sort_dropdown',
  COLUMN_HEADER = 'column_header',
}

export function trackSortsApplied(metadata: {
  sortWidget: SortWidget;
  section: Section;
  isExpanded: boolean;
  searchParams: SearchParams;
}): void {
  analytics.deprecatedTrackEvent(NAV_ANALYTICS_ACTIONS.APPLIED_SORTS, metadata);
}

export function trackSortEvent(
  event: AnalyticsEvent,
  metadata: {
    sortWidget: SortWidget;
    section: Section;
    isExpanded: boolean;
  }
): void {
  analytics.deprecatedTrackEvent(event, metadata);
}
